import { render, staticRenderFns } from "./CharacterSelection.vue?vue&type=template&id=d4322db2&scoped=true"
import script from "./CharacterSelection.vue?vue&type=script&lang=js"
export * from "./CharacterSelection.vue?vue&type=script&lang=js"
import style0 from "./CharacterSelection.vue?vue&type=style&index=0&id=d4322db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4322db2",
  null
  
)

export default component.exports